import type { ComponentType } from 'react';
import { DEFAULT_LUCIDE_ICON_PROPS, type LucideIconName } from './constants';
import dynamic from 'next/dynamic';
import type { LucideProps } from 'lucide-react';

type DynamicLucideIcon = ComponentType<LucideProps>;

type IconMap = {
  [key in LucideIconName]: {
    icon: DynamicLucideIcon;
    props: LucideProps;
  };
};

export const iconMap: IconMap = {
  Menu: {
    icon: dynamic(() => import('lucide-react').then((mod) => mod.Menu)),
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
  Search: {
    icon: dynamic(() => import('lucide-react').then((mod) => mod.Search)),
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
  X: {
    icon: dynamic(() => import('lucide-react').then((mod) => mod.X)),
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
  RefreshCw: {
    icon: dynamic(() => import('lucide-react').then((mod) => mod.RefreshCw)),
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
  Clock: {
    icon: dynamic(() => import('lucide-react').then((mod) => mod.Clock)),
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
  ChevronRight: {
    icon: dynamic(() => import('lucide-react').then((mod) => mod.ChevronRight)),
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
  Mail: {
    icon: dynamic(() => import('lucide-react').then((mod) => mod.Mail)),
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
};

export interface IconProps extends LucideProps {
  icon: LucideIconName;
  className?: string;
}

export const Icon = (props: IconProps) => {
  const { icon, className, size = 24 } = props;

  const Icon = iconMap[icon].icon;
  if (!Icon) return null;

  const iconProps = iconMap[icon].props;

  return (
    <Icon
      style={{ flexShrink: 0 }}
      className={className}
      size={size}
      {...iconProps}
      {...props}
    />
  );
};
